

import React, { useEffect, useId, useRef, useState } from 'react';
import { ColorChangeHandler, SketchPicker } from "react-color"
import reactCSS from 'reactcss'
import type { Property } from "csstype"
import { ValueSetGet } from '../../../Editor/shapes/shapeHelper/getSetProperties';

interface ColorInputProp extends ValueSetGet<ColorValue> {
  properyDisplayName: string;
}

// interface ColorInputProp {
//   properyItem: GeometricShape,
//   propertyName: string,
//   properyDisplayName: string,
//   injection?: ActionCreatorWithPayload<{
//     id: string;
//     propertyValue: ColorValue;
//     propertyName: string;
//   }>,
// }

// function getPropertyItemPropertyFromName(properyItem: GeometricShape, propertyName: string) {
//   function hasKey<O extends GeometricShape>(obj: O, key: PropertyKey): key is keyof O {
//     return key in obj
//   }
//   if (hasKey(properyItem, propertyName)) {
//     return properyItem[propertyName];
//   } else {
//     console.error(`${propertyName} not valid string index.`)
//   };
// }

const ColorInput = ({ properyDisplayName, currentValue, setValue }: ColorInputProp) => {

  const inputID = useId();
  const [localColor, setLocalColor] = useState<ColorValue>(currentValue)//getPropertyItemPropertyFromName(properyItem, propertyName) as ColorValue)
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false)
  const colorMenuReference = useRef<HTMLDivElement>(null)
  const colorButtonReference = useRef<HTMLDivElement>(null)

  // const onChangeFunction = injection ?
  //   (color: ColorValue) => injection({ id: properyItem.type, propertyValue: color, propertyName: propertyName }) :
  //   (color: ColorValue) => changeColorValue({ id: properyItem.id, propertyValue: color, propertyName: propertyName });

  useEffect(() => {
    const handleClickOutsideOfPalette = (e: MouseEvent) => {
      if (displayColorPicker &&
        !colorMenuReference.current?.contains(e.target as Node) &&
        !colorButtonReference.current?.contains(e.target as Node)
      ) {
        setDisplayColorPicker(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutsideOfPalette)

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideOfPalette)
    }
  })

  const handleLocalChange: ColorChangeHandler = (color, e) => {
    setLocalColor(color.hex as ColorValue);
  }

  const handleCompleteChange: ColorChangeHandler = (color, e) => {
    setLocalColor(color.hex as ColorValue);
    setValue(color.hex as ColorValue)
    //dispatch(onChangeFunction(color.hex as ColorValue))
  };

  const styles = reactCSS({
    'default': {
      color: {
        width: '100px',
        height: '14px',
        borderRadius: '1px',
        background: localColor,
      },
      swatch: {
        padding: '1px',
        background: '#fff',
        borderRadius: '0px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute' as Property.Position,
        zIndex: 2,
      },
    },
  });

  return (
    <>
      <label htmlFor={inputID} className='element__part__name'>
        {properyDisplayName}
      </label>
      <div ref={colorButtonReference}>
        <button
          style={styles.swatch}
          //ref={colorButtonReference}
          onClick={() => setDisplayColorPicker(!displayColorPicker)}
        >
          <div style={styles.color} />
        </button>
      </div>

      {displayColorPicker ?
        <div ref={colorMenuReference} style={styles.popover}>
          <SketchPicker

            color={localColor}
            onChangeComplete={handleCompleteChange}
            onChange={handleLocalChange}
          />
        </div> : null
      }
    </>
  );
}


export default ColorInput;


